// Path: ./src/utils/generateUniqueNumber.ts
export function generateUniqueNumber() {
  const now = new Date();
  const day = now.getDate();
  const month = now.getMonth() + 1;
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();

  const randomNumber = `${day}${month}${hours}${minutes}${seconds}${Math.floor(
    Math.random() * 100
  )}`;

  return randomNumber;
}
